import React, {useEffect, useState} from "react";
import {download, generateCsv, mkConfig} from "export-to-csv"; // use named exports
import { Checkbox, Button, FormControlLabel, Dialog, DialogContent, Stack } from "@mui/material";
import * as XLSX from "xlsx";
import type { MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState } from "material-react-table";
import { useGetPianAttDTO } from "./Services";
import { PianAttDTO } from "./types";


interface PianAttExpProps {
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  globalFilter: string;
  sorting: MRT_SortingState;
  onClose: () => void;
}

const PianAttExp: React.FC<PianAttExpProps> = ({
  pagination,
  columnFilters,
  globalFilter,
  sorting,
  onClose,
}) => {
  // const repoPianAttFields = [
  //   "nrrel",    "ditta",    "datareg",    "variante",    "opzione",    "coddip",    "oreord",    "minord",    "codprog",    "note",
  //   "codatt",    "codnodo",    "datains",    "desnodo",    "desatt",    "codagente",    "codcli",    "nomeagente",    "ref",
  //   "flgval",    "ore",    "ragsoccli",    "desditta",    "desprog",
  // ];
 const repoPianAttDTOFields = [
  "id","ditta","idcli","desragsoccli","codprog","desprog","codnodo","desnodo","ref",
  "datainiziopian","datafinepian","datainizioeff","datafineeff","note","coddip","priorita",
];

  const { data: { results = [] } = {} } = useGetPianAttDTO(
    { pageIndex: 0, pageSize: 100000 },
    columnFilters,
    globalFilter,
    sorting
  );

  const [selectedFields, setSelectedFields] = useState<string[]>(repoPianAttDTOFields);



  const generateExcelData = () => {
    return results.map((repoPianAttDTO) => {
      const rowData: any = {};
      selectedFields.forEach((field) => {
        rowData[field] = repoPianAttDTO[field as keyof PianAttDTO] || "";
      });
      return rowData;
    });
  };

  const handleFieldToggle = (field: string) => {
    setSelectedFields((prevFields) =>
      prevFields.includes(field)
        ? prevFields.filter((item) => item !== field)
        : [...prevFields, field]
    );
  };

  const handleExportExcel = () => {
    const excelData = generateExcelData();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PianAttExcel");
    XLSX.writeFile(workbook, "PianAtt.xlsx");
  };

  const csvConfig = mkConfig({
            filename: "PianAtt",
            fieldSeparator: ";",
            decimalSeparator: ",",
            useKeysAsHeaders: true,
            showColumnHeaders: true,
          });
const handleExportCSV = () => {
    const selectedData = results.map((PianAttDTO) => {
      const rowData: any = {};

      selectedFields.forEach((field) => {
        rowData[field] = PianAttDTO[field as keyof PianAttDTO] || "";
      });
      return rowData;
    });

    const csv = generateCsv(csvConfig)(selectedData);
    download(csvConfig)(csv);
  };

  return (
 <Dialog onClose={onClose} open fullWidth maxWidth="md">
  <DialogContent>
    <h4>Seleziona Campi da esportare:</h4>
    <form>
      <Stack direction="row" spacing={2} flexWrap="wrap">
        {repoPianAttDTOFields.map((field) => (
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedFields.includes(field)}
                  onChange={() => handleFieldToggle(field)}
                />
              }
              label={field}
            />
          </Stack>
        ))}
      </Stack>
    </form>
  </DialogContent>

  <DialogContent>
    <Stack direction="row" spacing={2} flexWrap="wrap">
      <Stack>
        <Button
          fullWidth
          color="primary"
          variant="outlined"
          onClick={() => setSelectedFields(repoPianAttDTOFields)}
        >
          SELEZIONA TUTTI
        </Button>
      </Stack>
      <Stack>
        <Button
          fullWidth
          color="primary"
          variant="outlined"
          onClick={() => setSelectedFields([])}
        >
          DESELEZ. TUTTI
        </Button>
      </Stack>
      <Stack>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={handleExportCSV}
        >
          EXPORT TO CSV
        </Button>
      </Stack>
      <Stack>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={handleExportExcel}
        >
          EXPORT TO EXCEL
        </Button>
      </Stack>
      <Stack>
        <Button fullWidth variant="contained" onClick={onClose} color="error">
          CHIUDI
        </Button>
      </Stack>
      </Stack>
    </DialogContent>
  </Dialog>
  );
};

export default PianAttExp;
